<template>
    <div>
        <div class="tw-rounded tw-bg-gray-0 tw-p-4 tw-mt-2 tw-shadow-card" v-if="user.email_change !== null">
        <span class="normal-text tw-font-normal tw-flex tw-items-center">
            <i class="far fa-exclamation-triangle tw-text-red-500" style="margin-top: 0; margin-right: 10px;"></i>
            {{ translations['profile.change_email_send_to'] }}
            {{ user.email_change.email }}.
            {{ translations['profile.click_link_to_change_email'] }}
        </span>
        </div>
    </div>
</template>

<script>
    import Global from '../mixins/Global';

    export default {
        name: 'ProfileEmailField',

        mixins: [Global],

        data() {
            return {
                user,
            };
        },
    };
</script>
